import { render, staticRenderFns } from "./toGuildLeader.vue?vue&type=template&id=ceb2cb98&scoped=true"
import script from "./toGuildLeader.vue?vue&type=script&lang=js"
export * from "./toGuildLeader.vue?vue&type=script&lang=js"
import style0 from "./toGuildLeader.vue?vue&type=style&index=0&id=ceb2cb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb2cb98",
  null
  
)

export default component.exports